// © Microsoft Corporation. All rights reserved.
/**
 * Returns the cookie content given a name
 * @param cookieString {string} - cookie string (usually comes via `document.cookie` for client-side JS)
 * @param name {string} - cookie name
 * @returns the value of the cookie or `null`, if the key is not found.
 */
export function getCookieCore(cookieString, name) {
    if (cookieString) {
        const re = new RegExp("\\b" + name + "\\s*=\\s*([^;]*)", "i");
        const match = re.exec(cookieString);
        return (match && match.length > 1 ? match[1] : null);
    }
    return null;
}
//# sourceMappingURL=GetCookieCore.js.map